import { createSlice } from "@reduxjs/toolkit";

export const appInitializeSlice = createSlice({
  name: "metaData",
  initialState: {
    urlPaths: [],
    useLocalLogo: false,
    useLocalSplash: false,
    useLocalBanner: false,
    config: {} as any,
  },
  reducers: {
    setURLPaths: (state, action) => {
      state.urlPaths = action.payload;
    },
    setLocalAssets: (state: any, action: any) => {
      state[action.payload.key] = action.payload.flag;
    },
    setConfig: (state, action: any) => {
      state.config = action.payload;
    },
  },
});

export const { setURLPaths, setLocalAssets, setConfig } =
  appInitializeSlice.actions;

export default appInitializeSlice.reducer;
